import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'BROJSans-Regular'; 
    src: url('/src/assets/fonts/BROJSans-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'BROJSans-Medium'; 
    src: url('/src/assets/fonts/BROJSans-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'BROJSans-SemiBold'; 
    src: url('/src/assets/fonts/BROJSans-SemiBold.otf') format('opentype');
    font-weight: 600;
    font-style: normal;
  }
  @font-face {
    font-family: 'BROJSans-Bold'; 
    src: url('/src/assets/fonts/BROJSans-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  /* CSS Reset */
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  /* Reset specific elements */
  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  body, h1, h2, h3, h4, p, ul, ol, li, figure, figcaption, blockquote, dl, dd {
    margin: 0;
    padding: 0;
  }

  /* Global font settings */
  :root {
    --desktop-headline-1-font-family: "BRAD Sans", Helvetica, Arial, sans-serif;
    --desktop-headline-1-font-size: 32px;
    --desktop-headline-1-font-style: normal;
    --desktop-headline-1-font-weight: 700;
    --desktop-headline-1-letter-spacing: 0.05em;
    --desktop-headline-1-line-height: 1.5;

    --desktop-title-1-font-family: "BRAD Sans", Helvetica, Arial, sans-serif;
    --desktop-title-1-font-size: 24px;
    --desktop-title-1-font-style: normal;
    --desktop-title-1-font-weight: 600;
    --desktop-title-1-letter-spacing: 0.02em;
    --desktop-title-1-line-height: 1.4;

    --text-dark-text-default: rgba(255, 255, 255, 1);
  }
  * {
    font-family: 'BROJSans-SemiBold', Helvetica, sans-serif; /* 기본 SemiBold 폰트 적용 */
    font-weight: 600;
  }
  
`;

export default GlobalStyle;
